import type { CardAddress } from '@apps/card/routes/CardCustomizer/CardCustomizer.types';

export const isPoBoxAddress = (address: CardAddress | undefined) => {
  if (!address) return false;

  const poBoxRegex = /P(.?\s?O.?)?\s?Box/i;
  return poBoxRegex.test(address.address1);
};
